export const reduceGapClassMap = {
  default: "lg:mt-[-10%]",
  50: "lg:mt-[-50px]",
  100: "lg:mt-[-100px]",
  150: "lg:mt-[-150px]",
  200: "lg:mt-[-200px]",
};

export type ReduceGap = keyof typeof reduceGapClassMap;
